export function initSearchSpain(){

  if (cube.$id('search-es')) {
    import(/* webpackChunkName: "sa-search-es" */ './sa-search-es/sa-search-es').then(
      ({ init }) => {
        init();
      }
    );
  }

  if (cube.$('.l-search-form')) {
    import(/* webpackChunkName: "sa-autocomplete-es" */ './sa-autocomplete-es/sa-autocomplete-es').then(
      ({ init }) => {
        init();
      }
    );
  }

}





// WEBPACK FOOTER //
// ./src/search-spain/search-spain.entry.js